module.exports = __webpack_public_path__ + "img/um.cae1a345.svg";